import React from 'react';

/**
 * Shimmer placeholder for content that is still loading (e.g. charts while a
 * backtest is running). Uses the `skeleton-shimmer` keyframe in index.css.
 */
export default function Skeleton({ width = '100%', height = 16, radius = 'var(--radius-md)', style = {} }) {
  return (
    <div
      aria-hidden="true"
      style={{
        width,
        height,
        borderRadius: radius,
        background: 'linear-gradient(90deg, var(--card) 25%, var(--surface) 37%, var(--card) 63%)',
        backgroundSize: '200% 100%',
        animation: 'skeleton-shimmer 1.4s ease-in-out infinite',
        ...style,
      }}
    />
  );
}
